// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"1024f5a7","703":"e0c8ff06"}[chunkId] + ".chunk.js";
};